import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResourcesComponent } from './resources/resources.component';
import { AuthGuardService } from '../auth/services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: ResourcesComponent,
    canActivate: [ AuthGuardService ]
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})

export class ResourceRoutingModule { }
